/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 *      keep in sync with the code):
 *   role:      lib — reads a group-course date on the ski school's calendar (Europe/Rome)
 *   exports:   SCHOOL_TZ, schoolDay(value, format?), schoolNow()
 *   callers:   controllers/detail.js (showBuyProductF, showBuyEvent, freeGroupPriceTask,
 *              addGroupsCartTask), controllers/user.js (package day windows),
 *              helpers/format-day-locale.js (SCHOOL_TZ)
 *
 * /ecommerce_dashboard sends the same departure in two shapes: the event as a bare
 * date ("2027-02-15") and its availability as an instant ("2027-02-15T00:00:00+01:00").
 * Plain `moment()` reads both in the BROWSER's zone, so for a customer on
 * Europe/London the availability lands on 14/02 23:00 while the event stays on 15/02:
 * the same-day check failed, the card closed on itself and the date posted to
 * /scuolasci_freeprice and /get_giorni_partenza_collettiva was the day before (POP-698).
 * Courses run at the school, so every day comparison and every date the API reads
 * goes through the school's zone, whatever the visitor's machine is set to.
 */
import moment from 'moment-timezone';

export const SCHOOL_TZ = 'Europe/Rome';

/**
 * @param {string|Date|moment.Moment} value bare date, or an instant with offset
 * @param {string} [format] moment parse format, when the value needs one
 * @returns {moment.Moment} the value on the school's calendar; a bare date is that
 *   day at 00:00 in the school's zone, an instant is converted to the school's zone
 */
export function schoolDay(value, format) {
  return format ? moment.tz(value, format, SCHOOL_TZ) : moment.tz(value, SCHOOL_TZ);
}

/**
 * "Now" on the school's calendar: day-unit checks against a schoolDay() (is the
 * lesson before today? N days ahead?) must count days in the school's zone too.
 * @returns {moment.Moment}
 */
export function schoolNow() {
  return moment.tz(SCHOOL_TZ);
}
